export default __webpack_public_path__ + "static/media/programing.a0e04170.webp";